export interface InstallStep {
  id: string;
  title: string;
  desc: string;
}

export interface InstallPlatform {
  id: string;
  tab: string;
  icon: string;
  badge: string;
  packageName: string;
  packageSize: string;
  systemReq: string;
  summary: string;
  steps: InstallStep[];
}

export const mobilePlatforms: InstallPlatform[] = [
  {
    id: "android",
    tab: "Android 手机版",
    icon: "ri-android-line",
    badge: "APK 直装",
    packageName: "xingchen-player-android-v3.2.1.apk",
    packageSize: "约 42.6 MB",
    systemReq: "Android 5.0 及以上",
    summary: "适合绝大多数安卓手机与平板，下载安装包后直接安装即可使用。",
    steps: [
      {
        id: "android-1",
        title: "访问官方下载页",
        desc: "使用手机或电脑浏览器打开本页，向下滑动到「手机版安装」区域，准备好下载环境。",
      },
      {
        id: "android-2",
        title: "下载 Android 版安装包",
        desc: "点击「下载 Android 版」按钮，浏览器会保存一个 .apk 安装文件，等待下载完成。",
      },
      {
        id: "android-3",
        title: "允许安装未知来源应用",
        desc: "若系统提示限制，进入「设置 → 安全（或应用管理）」，为当前浏览器允许“安装未知应用”。",
      },
      {
        id: "android-4",
        title: "点击安装包完成安装",
        desc: "在通知栏或「文件管理 → 下载」中找到安装包，点击「安装」，等待进度完成。",
      },
      {
        id: "android-5",
        title: "打开并登录使用",
        desc: "安装完成后点击「打开」，注册或登录账号，即可进入首页浏览影视内容。",
      },
    ],
  },
  {
    id: "ios",
    tab: "iPhone 手机版",
    icon: "ri-apple-line",
    badge: "描述文件",
    packageName: "xingchen-player-ios-v3.2.1.mobileconfig",
    packageSize: "约 8.4 MB",
    systemReq: "iOS 12.0 及以上",
    summary: "通过描述文件或测试版本方式安装，安装后需在设置中手动信任开发者。",
    steps: [
      {
        id: "ios-1",
        title: "在 Safari 中打开下载页",
        desc: "请使用系统自带的 Safari 浏览器打开本页，其他浏览器可能无法正常唤起安装流程。",
      },
      {
        id: "ios-2",
        title: "获取 iOS 版安装文件",
        desc: "点击「下载 iOS 版」按钮，按页面提示允许下载描述文件或进入测试版本安装入口。",
      },
      {
        id: "ios-3",
        title: "信任开发者证书",
        desc: "前往「设置 → 通用 → VPN 与设备管理」，找到对应描述文件并点击「信任」。",
      },
      {
        id: "ios-4",
        title: "返回桌面打开使用",
        desc: "证书信任后返回桌面，找到星辰影视图标，点击打开并登录账号即可。",
      },
    ],
  },
];

export const tvPlatforms: InstallPlatform[] = [
  {
    id: "tv",
    tab: "智能电视 / TV 盒子",
    icon: "ri-tv-2-line",
    badge: "U 盘安装",
    packageName: "xingchen-player-tv-v3.2.1.apk",
    packageSize: "约 38.2 MB",
    systemReq: "Android TV 7.0 及以上",
    summary: "适用于智能电视与电视盒子，通过 U 盘拷贝安装包后本地安装，遥控操作更顺手。",
    steps: [
      {
        id: "tv-1",
        title: "下载 TV 版安装包",
        desc: "在电脑或手机上下载 TV 版 .apk 文件，注意不要解压，保持原始文件格式。",
      },
      {
        id: "tv-2",
        title: "拷贝到 U 盘",
        desc: "将 U 盘插入电脑，把安装包复制到 U 盘根目录，方便在电视端快速找到。",
      },
      {
        id: "tv-3",
        title: "连接电视并打开文件管理",
        desc: "把 U 盘插入电视或盒子的 USB 接口，打开电视自带的「文件管理」或「媒体中心」。",
      },
      {
        id: "tv-4",
        title: "允许未知来源并安装",
        desc: "在文件管理中找到安装包，按提示允许安装未知来源应用，点击「安装」。",
      },
      {
        id: "tv-5",
        title: "在应用列表打开",
        desc: "安装完成后，回到电视「应用」列表，找到星辰影视图标，用遥控器打开使用。",
      },
    ],
  },
];

export interface DeviceItem {
  id: string;
  category: string;
  categoryLabel: string;
  name: string;
  icon: string;
  system: string;
  packageType: string;
  note: string;
}

export const deviceCategories: { id: string; label: string }[] = [
  { id: "all", label: "全部设备" },
  { id: "mobile", label: "手机 / 平板" },
  { id: "tv", label: "电视 / 盒子" },
  { id: "desktop", label: "电脑 / 网页" },
];

export const devices: DeviceItem[] = [
  {
    id: "dev-android",
    category: "mobile",
    categoryLabel: "手机 / 平板",
    name: "Android 手机与平板",
    icon: "ri-smartphone-line",
    system: "Android 5.0 及以上",
    packageType: "手机版 APK",
    note: "覆盖主流安卓机型，支持横竖屏切换与手势操作。",
  },
  {
    id: "dev-ios",
    category: "mobile",
    categoryLabel: "手机 / 平板",
    name: "iPhone 与 iPad",
    icon: "ri-apple-line",
    system: "iOS 12.0 及以上",
    packageType: "iOS 描述文件",
    note: "需在设置中信任开发者证书后方可使用。",
  },
  {
    id: "dev-harmony",
    category: "mobile",
    categoryLabel: "手机 / 平板",
    name: "鸿蒙 HarmonyOS 设备",
    icon: "ri-device-line",
    system: "HarmonyOS 2.0 及以上",
    packageType: "手机版 APK",
    note: "开启兼容模式安装，多数机型可正常运行。",
  },
  {
    id: "dev-tv",
    category: "tv",
    categoryLabel: "电视 / 盒子",
    name: "Android TV 智能电视",
    icon: "ri-tv-2-line",
    system: "Android TV 7.0 及以上",
    packageType: "TV 版 APK",
    note: "适配小米、华为、索尼等主流品牌电视。",
  },
  {
    id: "dev-box",
    category: "tv",
    categoryLabel: "电视 / 盒子",
    name: "智能电视盒子",
    icon: "ri-hard-drive-2-line",
    system: "Android 7.0 及以上",
    packageType: "TV 版 APK",
    note: "通过 U 盘安装，遥控器操作界面已做放大处理。",
  },
  {
    id: "dev-windows",
    category: "desktop",
    categoryLabel: "电脑 / 网页",
    name: "Windows 电脑",
    icon: "ri-windows-fill",
    system: "Windows 10 及以上",
    packageType: "网页版",
    note: "免安装，浏览器直接访问，支持全屏观看。",
  },
  {
    id: "dev-mac",
    category: "desktop",
    categoryLabel: "电脑 / 网页",
    name: "Mac 电脑",
    icon: "ri-macbook-line",
    system: "macOS 10.15 及以上",
    packageType: "网页版",
    note: "Safari 与 Chrome 均可稳定播放。",
  },
  {
    id: "dev-projector",
    category: "tv",
    categoryLabel: "电视 / 盒子",
    name: "智能投影仪",
    icon: "ri-projector-2-line",
    system: "Android 7.0 及以上",
    packageType: "TV 版 APK",
    note: "支持侧投矫正与遥控操作，适合卧室大屏观影。",
  },
];